<template>
  <section v-if="advertisements.length" class="carnival-advertisements" aria-label="活动推荐">
    <template v-for="advertisement in advertisements" :key="advertisement.key">
      <a v-if="advertisement.href" :href="disabled ? undefined : advertisement.href" :target="advertisement.external ? '_blank' : undefined" :rel="advertisement.external ? 'noopener noreferrer' : undefined" :aria-disabled="disabled || undefined" :tabindex="disabled ? -1 : undefined" :aria-label="advertisement.name || '查看活动推荐'" @click="open($event, advertisement)">
        <picture><source v-if="advertisement.smallImage" media="(max-width: 480px)" :srcset="advertisement.smallImage" /><img :src="advertisement.image" :alt="advertisement.name || '活动推荐'" loading="lazy" /></picture>
      </a>
      <picture v-else><source v-if="advertisement.smallImage" media="(max-width: 480px)" :srcset="advertisement.smallImage" /><img :src="advertisement.image" :alt="advertisement.name || '活动推荐'" loading="lazy" /></picture>
    </template>
  </section>
</template>
<script setup>
import { computed } from 'vue';
import { carnivalAdvertisements } from '../../services/activities/carnivalPresentation.mjs';
const props = defineProps({ activity: { type: Object, default: null }, disabled: Boolean });
const advertisements = computed(() => carnivalAdvertisements(props.activity, 'PC'));
function open(event) { if (props.disabled) event.preventDefault(); }
</script>
<style scoped>
.carnival-advertisements { display: grid; gap: 12px; margin: 16px; }
.carnival-advertisements a, .carnival-advertisements picture, .carnival-advertisements img { display: block; width: 100%; }
.carnival-advertisements img { height: auto; border-radius: 8px; }
.carnival-advertisements a:focus-visible { outline: 2px solid var(--act-brand, #179cff); outline-offset: 4px; }
.carnival-advertisements a[aria-disabled] { cursor: default; }
</style>
